import { REACT_APP_COUNTRY } from '../../envVars';
import { DynamicObjectInterface } from '../../sdk/type';
import { LoggerService } from './logger';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    utag: DynamicObjectInterface;
    utag_data: DynamicObjectInterface;
  }
}

interface TrackEvent {
  eventName?: string;
  data: DynamicObjectInterface;
}

interface PageDetailsOptions {
  page_category: string;
  page_name: string;
  page_section: string;
  page_subsection: string;
}

type PageType = (typeof PAGES)[keyof typeof PAGES];

const AFFILIATE_NUMBER = REACT_APP_COUNTRY === 'ID' ? 220 : REACT_APP_COUNTRY === 'PH' ? 350:  100;

export const LINK_EVENTS: string[] = [];

export const PAGES = {
  dashboard: 'DASHBOARD',
  campaignDashboard: 'CAMPAIGNDASHBOARD',
  joinTeam: 'JOINTEAM',
  registerForm: 'REGISTERFORM',
  createTeam: 'CREATETEAM',
  coachEnrollment: 'COACHENROLLMENT',
  coachList: 'COACHLIST',
  teamDetails: 'TEAMDETAILS',
  teamList: 'TEAMLIST',
  teamProfile: 'TEAMPROFILE',
  addParticipant: 'ADDPARTICIPANT',
  dsw:"DSW",
} as const;

const trackEvent = ({ eventName, data }: TrackEvent) => {
  if (typeof window === 'undefined') return;
  if (!window.utag) return;

  const authDetails = getAuthDetails();
  try {
    if (LINK_EVENTS.some(event => event === eventName)) {
      return window.utag.link({
        ...window.utag_data,
        ...authDetails,
        ...data,
      });
    }
    return window.utag.view({
      ...window.utag_data,
      ...authDetails,
      ...{
        ...(eventName && { event_name: eventName }),
        ...data,
      },
    });
  } catch (error) {
    LoggerService.log('Error trackEvent', error);
  }
};

export const trackPage = (page: PageType) => {
  if (!page) return;
  return trackEvent({
    data: {
      ...getPageDetails(page),
    },
  });
};

const getPageDetails = (page: PageType, options?: PageDetailsOptions) => ({
  ...(PAGE_PROPERTIES[page] ?? {}),
  ...(options ?? {}),
});

const getAuthDetails = () => {
  const loginId = localStorage.getItem('loginId');
  if (!loginId) {
    return {
      visitor_userProfile: 'guest',
    };
  }
  return {
    visitor_imcID: getIMCID(loginId),
    visitor_partyID: localStorage.getItem('globalPartyID'),
    visitor_pinNumber: localStorage.getItem('pinNumber'),
    visitor_userProfile: 'abo',
  };
};

const getIMCID = (loginId: string) => massageAttrVal(AFFILIATE_NUMBER * 100000000000 + Number(loginId));

const massageAttrVal = (val: number) => String(val != null ? val : 'none');

const PAGE_PROPERTIES = {
  DASHBOARD: {
    page_category: 'landing-dashboard',
    page_name: 'landing-dashboard',
    page_section: 'landing-dashboard',
    page_subCategory: 'landing-dashboard',
  },
  CAMPAIGNDASHBOARD: {
    page_category: 'campaign-dashboard',
    page_name: 'campaign-dashboard',
    page_section: 'campaign-dashboard',
    page_subCategory: 'campaign-dashboard',
  },
  JOINTEAM: {
    page_category: 'join-team',
    page_name: 'join-team',
    page_section: 'join-team',
    page_subCategory: 'join-team',
  },
  REGISTERFORM: {
    page_category: 'register-form',
    page_name: 'register-form',
    page_section: 'register-form',
    page_subCategory: 'register-form',
  },
  CREATETEAM: {
    page_category: 'create-team',
    page_name: 'create-team',
    page_section: 'create-team',
    page_subCategory: 'create-team',
  },
  COACHENROLLMENT: {
    page_category: 'coach-enrollment',
    page_name: 'coach-enrollment',
    page_section: 'coach-enrollment',
    page_subCategory: 'coach-enrollment',
  },
  COACHLIST: {
    page_category: 'coach-list',
    page_name: 'coach-list',
    page_section: 'coach-list',
    page_subCategory: 'coach-list',
  },
  TEAMDETAILS: {
    page_category: 'team-details',
    page_name: 'team-details',
    page_section: 'team-details',
    page_subCategory: 'team-details',
  },
  TEAMLIST: {
    page_category: 'team-list',
    page_name: 'team-list',
    page_section: 'team-list',
    page_subCategory: 'team-list',
  },
  TEAMPROFILE: {
    page_category: 'team-profile',
    page_name: 'team-profile',
    page_section: 'team-profile',
    page_subCategory: 'team-profile',
  },
  ADDPARTICIPANT: {
    page_category: 'add-participant',
    page_name: 'add-participant',
    page_section: 'add-participant',
    page_subCategory: 'add-participant',
  },
  DSW:{
    page_category: 'digital-scratch',
    page_name: 'digital-scratch',
    page_section: 'digital-scratch',
    page_subCategory: 'digital-scratch',
  }
};
